
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/aapne-skisteder",
      function () {
        return require("private-next-pages/[region]/aapne-skisteder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/aapne-skisteder"])
      });
    }
  